import axios from 'axios'
import { getCookie } from './cookie';
import { logoutFromInterceptor } from './logout';

const BASE_URL = process.env.REACT_APP_BASE_URL ||'https://api.mountq.be/MountQAPI/v1/'


const axiosInstance = axios.create({
    baseURL: BASE_URL,
    headers: {
        'Content-Type': 'application/json',
    },
});

// Add a request interceptor to attach the latest token from localStorage
axiosInstance.interceptors.request.use(
    (config) => {
        const token = getCookie('mq-token');
        if (token) {
            config.headers['Authorization'] = `Bearer ${token}`;
        }
        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);

axiosInstance.interceptors.response.use(
    (response) => {
        // Return the response as-is if the status is not an error
        return response;
    },(error) => {
        // Redirect to /login if status code is 403 or 401
    if (error.response?.status === 403 || error.response?.status === 401) {
      logoutFromInterceptor();
    }
        return Promise.reject(error);
    }
);

export default axiosInstance;

export const axiosPrivate = axios.create({
    baseURL: BASE_URL,
    headers: { 'Content-Type': 'application/json' }
})

axiosPrivate.interceptors.response.use(
    (response) => {
        return response;
    },
    (error) => {
        if (error.response && error.response.status === 405) {
            logoutFromInterceptor();
        }
        return Promise.reject(error);
    }
);